// extracted by mini-css-extract-plugin
export default {"blogs-container":"BlogsContainer_blogs-container__HNpio"};